"use client";

import dynamic from "next/dynamic";
import type { ComponentProps, FC } from "react";

import { Loader } from "components/atoms/Loader/Loader";

import type { MapboxMap } from "./MapboxMap";

const MapboxMapLazy = dynamic(
  () => import("./MapboxMap").then((module) => ({ default: module.MapboxMap })),
  {
    ssr: false,
    loading: () => <Loader />,
  },
);

type MapboxMapProps = ComponentProps<typeof MapboxMap>;

export const MapboxMapDynamic: FC<MapboxMapProps> = (props) => <MapboxMapLazy {...props} />;
